import { EServerPath } from '~/models/api'

const queryKeys = {
  organization: (id: string) => [EServerPath.organization, id],
  adminOrganization: (id: string) => [EServerPath.adminOrganization, id],
  adminOrganizationUsersCapabilities: (id: string) => [
    EServerPath.adminOrganizationUsersCapabilities,
    id,
  ],
  currentOrgPlan: (organizationId: string) => [
    EServerPath.organizationCurrentPlan,
    organizationId,
  ],
  trialDaysLeft: (organizationId: string) => [
    EServerPath.trialDaysLeft,
    organizationId,
  ],
  referralUICustomizations: (filters: object = {}) => [
    EServerPath.getRefferalUICustomization,
    filters,
  ],
}

export default queryKeys
